import { Injectable } from "@angular/core";
import { Store, select } from "@ngrx/store";
import {
  RoomCreateCmd,
  RoomDeleteCmd,
  RoomsListCmd,
  RoomUpdate2Cmd
} from "@youm-front/room/domain";
import { RoomsListActions } from "../actions";
import { RoomsListSelectors } from "../selectors";

@Injectable()
export class RoomsListFacade {
  isLoading$ = this.store.pipe(select(RoomsListSelectors.isLoading));
  rooms$ = this.store.pipe(select(RoomsListSelectors.rooms));

  constructor(private readonly store: Store) {}

  roomCreate(roomCreateCmd: RoomCreateCmd) {
    this.store.dispatch(RoomsListActions.roomCreate({ roomCreateCmd }));
  }

  roomDelete(roomDeleteCmd: RoomDeleteCmd) {
    this.store.dispatch(RoomsListActions.roomDelete({ roomDeleteCmd }));
  }

  roomUpdate(roomUpdateCmd: RoomUpdate2Cmd) {
    this.store.dispatch(RoomsListActions.roomUpdate({ roomUpdateCmd }));
  }

  roomsList() {
    this.store.dispatch(
      RoomsListActions.roomsList({ roomsListCmd: new RoomsListCmd({}) })
    );
  }
}
